import React from 'react';
import { TrendingUp } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

const StatCard = ({ title, value, icon: Icon, borderColor, isAmount, subtitle, testId }) => {
  return (
    <Card 
      className={`bg-white border border-slate-200 border-l-4 ${borderColor} shadow-sm hover:shadow-md transition-shadow duration-300`}
      data-testid={testId}
    >
      <CardContent className="p-6">
        <div className="flex items-start justify-between">
          <div>
            <p className="text-sm text-slate-500 font-medium mb-1">{title}</p>
            <p className={`font-heading text-3xl font-bold text-slate-800 ${isAmount ? 'text-2xl' : ''}`}>
              {value}
            </p>
          </div>
          <div className="w-12 h-12 rounded-xl bg-slate-50 flex items-center justify-center">
            <Icon className="w-6 h-6 text-slate-400" strokeWidth={1.5} />
          </div>
        </div>
        <div className="mt-4 flex items-center gap-1 text-xs text-slate-400">
          <TrendingUp className="w-3 h-3" />
          <span>Actualizado hoy</span>
        </div>
        {subtitle && (
          <p className="mt-2 text-xs text-slate-500">{subtitle}</p>
        )}
      </CardContent>
    </Card>
  );
};

export default StatCard;
